/**
 * Created by PuTi(编程即菩提) 10/23/17.
 */
var nb = require('../../core/js/nb');


var signatureUrl = 'http://appsupport.humming-tech.com/cgi';
var cmd = "weixin/signature";

var hideItems = ['menuItem:share:appMessage', 'menuItem:share:timeline',
    'menuItem:copyUrl', 'menuItem:share:qq', 'menuItem:share:weiboApp',
    'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari'];
var showItems = ['menuItem:share:appMessage', 'menuItem:share:timeline',
    'menuItem:copyUrl', 'menuItem:share:qq', 'menuItem:share:weiboApp',
    'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari'];

//    title: shareAppData.title,
//    desc: shareAppData.desc,
//    link: shareAppData.link,
//    imgUrl: shareAppData.imgUrl,
var shareAppOpts = {
    title: 'share app title',
    desc: 'share app description'
};
//    title: shareTimelineData.title || shareAppData.title,
//    link: shareTimelineData.link || shareAppData.link,
//    imgUrl: shareTimelineData.imgUr || shareAppData.imgUrl,
var shareTimelineOpts = {};

function initWX(json) {
    wx.config({
//			 debug : true,
        appId: json.appId,
        timestamp: json.timestamp,
        nonceStr: json.nonceStr,
        signature: json.signature,
        jsApiList: ['checkJsApi', 'onMenuShareTimeline',
            'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems', 'chooseImage', 'uploadImage','openLocation']
    });
};
module.exports = nb.define({
    parent: nb.Model,
    method: {
        isWeiXin:function(){
            return navigator.userAgent.match('MicroMessenger');
        },
        getSignature: function (inOpts) {
            var self = this;
            var opts = inOpts || {};
            var success = inOpts.success;
            nb.opts.$.ajax({
                //url:
                url: opts.url || signatureUrl,
                type: "post",
                contentType: "application/json;charset=UTF-8",
                dataType: "json",
                data: JSON.stringify({
                    cmd: opts.cmd || cmd,
                    parameters: {
                        //companyCode: opts.companyCode || '',
                        url: location.href
                    }
                }),
                success: function (inData) {
                    var statusCode = inData.statusCode;
                    if (statusCode == 0) {
                        initWX(inData.response);
                        if(success){
                            success.call(opts.scope);
                        }
                    }
                    self.refreshShareData();
                }
            });
        },
        refreshShareData:function(){
            wx.ready(function () {
                wx.onMenuShareAppMessage({
                    title: shareAppOpts.title,
                    desc: shareAppOpts.desc,
                    link: shareAppOpts.link,
                    imgUrl: shareAppOpts.imgUrl,
                    success: function () {
                        var cb = shareAppOpts.success;
                        if (cb) {
                            cb.call(shareAppOpts.scope);
                        }
                    }
                });
                wx.onMenuShareTimeline({
                    title: shareTimelineOpts.title || shareAppOpts.title,
                    link: shareTimelineOpts.link || shareAppOpts.link,
                    imgUrl: shareTimelineOpts.imgUr || shareAppOpts.imgUrl,
                    success: function () {
                        var cb = shareTimelineOpts.success;
                        if (cb) {
                            cb.call(shareTimelineOpts.scope);
                        }
                    }
                });
            });
        },
        setShareAppData: function (inOpts) {
            shareAppOpts = inOpts;
        },
        setShareTimelineData: function (inOpts) {
            shareTimelineOpts = inOpts
        },
        hideMenuItems: function (inOpts) {
            var opts = inOpts || {};
            var success = opts.success;
            var error = opts.error;
            wx.ready(function () {
                wx.hideMenuItems({
                    menuList: hideItems,
                    success: function (res) {
                        if (success) {
                            success.call(opts.scope);
                        }
                    },
                    fail: function (res) {
                        if (error) {
                            error.call(opts.scope);
                        }
                    }
                });
            });
        },
        showMenuItems: function (inOpts) {
            var opts = inOpts || {};
            var success = opts.success;
            var error = opts.error;
            wx.ready(function () {
                wx.showMenuItems({
                    menuList: showItems,
                    success: function (res) {
                        if (success) {
                            success.call(opts.scope);
                        }
                    },
                    fail: function (res) {
                        if (error) {
                            error.call(opts.scope);
                        }
                    }
                });
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/nb/wx/js/WXHelper.js
// module id = 34
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32